import axios from 'axios'

import { handleRequestError } from '../../actions/request'
import { ERROR_MESSAGE_SAVING } from '../../constants'

export const CREATE_USER_ADDRESS = 'CREATE_USER_ADDRESS'
export const RECEIVE_USER_ADDRESSES = 'RECEIVE_USER_ADDRESSES'
export const REQUEST_USER_ADDRESSES = 'REQUEST_USER_ADDRESSES'
export const SAVE_USER_ADDRESS = 'SAVE_USER_ADDRESS'

export const requestUserAddresses = () => (dispatch) => {
    dispatch({ type: REQUEST_USER_ADDRESSES })

    return axios
        .get('/useraddresses')
        .then((response) => {
            const items = response?.data || []
            dispatch(receiveUserAddresses({ items, fetchSuccessful: true }))
            return items
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receiveUserAddresses({ fetchSuccessful: true }))
                return
            }

            dispatch(receiveUserAddresses({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receiveUserAddresses = (data) => (dispatch) => {
    dispatch({ type: RECEIVE_USER_ADDRESSES, data })
}

export const saveUserAddress = (data) => (dispatch, getState) => {
    dispatch({ type: SAVE_USER_ADDRESS, data })

    const { id: userId } = getState().profile

    const { id } = data

    return axios
        .put(`/useraddresses/${id}`, { ...data, userId })
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receiveUserAddresses({ items: [responseData] }))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const createUserAddress = (data) => (dispatch, getState) => {
    dispatch({ type: CREATE_USER_ADDRESS, data })

    const { id: userId } = getState().profile

    return axios
        .post(`/useraddresses`, { ...data, userId })
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receiveUserAddresses({ items: [responseData] }))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}
